import React from "react";

import { Field } from "formik";

const TextAreaInput = ({
  id,
  name,
  labelText,
  placeholder,
  error,
  touched,
  classes,
}) => {
  return (
    <div className={`flex justify-center gap-1 flex-col ${classes}`}>
      <label
        htmlFor={name}
        className="text-md font-normal font-Nunito text-gray-700"
      >
        {labelText}
      </label>
      <div
        className={`outline-none border  w-full px-3 py-2 rounded-md focus:border-none focus:ring-1 focus:ring-blue-400 flex justify-between items-center ${
          error && touched ? "border-red-400" : "border-gray-400"
        }`}
      >
        <Field
          id={id}
          name={name}
          as="textarea"
          placeholder={placeholder}
          className="border-none outline-none w-full flex-grow resize-none"
        />
        {error && touched ? (
          <p className="text-xs font-normal font-Nunito text-red-500 pb-1">
            {error}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default TextAreaInput;
